import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FloatingCTA from '../../components/feature/FloatingCTA';
import { testimonials } from '../../mocks/testimonials';

export default function ReviewsPage() {
  return (
    <>
      <Header />
      <FloatingCTA />

      {/* Hero */}
      <section className="pt-32 pb-16 bg-brand-dark relative">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 text-brand-amber text-xs font-bold uppercase tracking-widest mb-5">
            <div className="h-px w-8 bg-brand-amber" />
            Customer Reviews
            <div className="h-px w-8 bg-brand-amber" />
          </div>
          <h1 className="font-serif text-5xl md:text-6xl font-bold text-white mb-5">
            What Jacksonville Homeowners Say About BBM Services
          </h1>
          <div className="flex items-center justify-center gap-1 mb-3">
            {[1,2,3,4,5].map((s) => <div key={s} className="w-7 h-7 flex items-center justify-center"><i className="ri-star-fill text-brand-amber text-xl" /></div>)}
          </div>
          <p className="text-white/70 text-xl">5.0 Average · 500+ Verified Reviews</p>
        </div>
      </section>

      {/* Review grid */}
      <section className="py-20 bg-brand-muted">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-14">
            {[...testimonials, ...testimonials].slice(0, 9).map((t, i) => (
              <div key={`${t.id}-${i}`} className="bg-white rounded-xl border border-stone-200 p-6">
                <div className="flex gap-0.5 mb-3">
                  {[1,2,3,4,5].map((s) => <div key={s} className="w-4 h-4 flex items-center justify-center"><i className="ri-star-fill text-brand-amber text-sm" /></div>)}
                </div>
                <p className="text-brand-light text-sm leading-relaxed mb-5">"{t.text}"</p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-full flex-shrink-0">
                      <span className="text-brand-amber font-bold text-sm">{t.initials}</span>
                    </div>
                    <div>
                      <div className="text-brand-dark font-semibold text-sm">{t.name}</div>
                      <div className="text-brand-warm-gray text-xs">{t.location} · {t.date}</div>
                    </div>
                  </div>
                  <div className="text-xs text-brand-warm-gray bg-stone-100 px-2 py-1 rounded-full whitespace-nowrap">{t.service}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Rating summary */}
          <div className="max-w-3xl mx-auto bg-white rounded-2xl border border-stone-200 p-8 text-center">
            <div className="font-serif text-6xl font-bold text-brand-dark mb-2">5.0</div>
            <div className="flex items-center justify-center gap-1 mb-3">
              {[1,2,3,4,5].map((s) => <div key={s} className="w-7 h-7 flex items-center justify-center"><i className="ri-star-fill text-brand-amber text-2xl" /></div>)}
            </div>
            <p className="text-brand-warm-gray text-lg mb-6">Based on 500+ verified reviews from Jacksonville, FL homeowners</p>
            <div className="grid grid-cols-3 gap-6 mb-6">
              {[
                { platform: 'Google', rating: '5.0', reviews: '320+' },
                { platform: 'Yelp', rating: '5.0', reviews: '110+' },
                { platform: 'Facebook', rating: '4.9', reviews: '85+' },
              ].map((p) => (
                <div key={p.platform} className="p-4 bg-stone-50 rounded-xl border border-stone-100">
                  <div className="font-bold text-brand-dark text-lg mb-0.5">{p.rating}</div>
                  <div className="text-brand-warm-gray text-xs">{p.platform} · {p.reviews} reviews</div>
                </div>
              ))}
            </div>
            <Link to="/contact" className="inline-block bg-brand-amber hover:bg-brand-amber-dark text-white font-bold py-3.5 px-10 rounded-lg text-base cursor-pointer whitespace-nowrap transition-all">Book Your Service</Link>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
